import type { Theme } from '@mui/material';

export const styles = {
  modal: (theme: Theme) => ({
    '.MuiPaper-root': {
      [theme.breakpoints.up('md')]: {
        width: '700px',
        // overwrite mui max-width setting
        maxWidth: '700px',
      },
    },
  }),

  headlineWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },

  headlineIcon: (theme: Theme) => ({
    color: theme.colors.neutral[500],
    marginRight: 1,
    display: 'flex',
  }),

  contentWrapper: {
    minHeight: '1px',
    lineHeight: '20px',
    position: 'relative',
    flexGrow: 1,
    flexShrink: 1,
  },

  contentWrapperNoMargin: {
    margin: 0,
  },
};
